import { createReducer } from '@reduxjs/toolkit'

import { Menu } from '@/model/menu'
import { Source } from '@/model/source'
import { axios } from '@/utils/axios'

import { createAppAsyncThunk } from './utils'

const namespace = 'source'

export const readAllSources = createAppAsyncThunk(
  `${namespace}/readAllSources`,
  async () => (await axios.get<Menu[]>(
    '/fanInsights/dict/source',
  )).data,
)

const initialState: {
  sources: Source[]
} = {
  sources: [],
}

const reducer = createReducer(initialState, (builder) => {
  builder.addCase(readAllSources.fulfilled, (draft, { payload }) => {
    draft.sources = payload
  })
})

export default { [namespace]: reducer }
